import { Navigate, useLocation } from "react-router-dom";
import DashboardLayout from "../../components/layouts/dashboardLayout";
import { getAuthToken, setRedirectRoute } from "../../utils/helpers/auth";

export const PrivateRoute = () => {
  const { pathname } = useLocation();

  if (!getAuthToken()) {
    setRedirectRoute(pathname);
    return <Navigate to="/login" />;
  }

  return <DashboardLayout />;
};
